import { COLORS } from 'data/color';
import { ResourceEndpoints } from 'data/endpoint';
import { useEffect, useState } from 'react';
import useColorSetStore from 'store/colorSet';
import useLanguageStore from 'store/languages';
import useLoadingStore from 'store/loading';
import useMachineStore from 'store/machine';
import { CategoryGroup } from 'types/category/category.type';
import styles from '../FacilityBar.module.scss';
import FacilityIcon from './icon/FacilityIcon';

type FacilityItemProps = {
  categoryGroup: CategoryGroup;
  isActive: boolean;
  handleClickItem: (facility: CategoryGroup) => void;
};

const FacilityItem = ({ categoryGroup, isActive, handleClickItem }: FacilityItemProps) => {
  const loadingStore = useLoadingStore();
  const langStore = useLanguageStore();
  const colorSetStore = useColorSetStore();
  const machineStore = useMachineStore();

  const [imageExists, setImageExists] = useState(false);

  const workspaceId = machineStore?.machine?.workspace.id;
  const categoryId = categoryGroup.id;
  const iconUrl = `${process.env.REACT_APP_RESOURCE_BASE_URL}${ResourceEndpoints.categoryIcon}/${workspaceId}/${categoryId}.svg`;

  useEffect(() => {
    const img = new Image();
    img.src = iconUrl;
    img.onload = () => setImageExists(true);
    img.onerror = () => setImageExists(false);
  }, [iconUrl]);

  const border = isActive ? `1px solid ${colorSetStore.sub}` : `1px solid ${colorSetStore.button.border}`;

  return (
    <button
      className={styles.facility}
      style={{
        background: isActive ? colorSetStore.sub : 'transparent',
        border,
        color: isActive ? COLORS.WHITE : colorSetStore.button.text,
      }}
      disabled={loadingStore.isLoadingMap}
      type='button'
      onClick={handleClickItem.bind(this, categoryGroup)}
    >
      {imageExists && (
        <div className={styles.icon}>
          <FacilityIcon iconUrl={iconUrl} iconColor={isActive ? COLORS.WHITE : colorSetStore.button.text} />
        </div>
      )}

      <div className={`${styles.name} ${isActive && styles.active}`}>{categoryGroup.name[langStore.currentLang]}</div>
    </button>
  );
};
export default FacilityItem;
